import e, { Component as t } from "react";
import n from "../../../../node_modules/classnames/index.js";
import { ENTER as r, RIGHT as o, LEFT as i, DOWN as s, UP as l, ESC as a } from "../../../constants/keyboard.js";
import { upcase as c } from "../../../utils/string/index.js";
function u(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function f(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function d(e) {
  return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function h(e, t) {
  return (h = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var v = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && h(e, t);
  }(g, t);
  var v,
    b,
    y,
    m = (v = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = d(g);
      if (v) {
        var r = d(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : u(this);
    });
  function g() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, g), e = m.apply(this, arguments), f(u(e), "container", void 0), f(u(e), "handlersRegistered", void 0), f(u(e), "_registerListeners", function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e.props;
      e.handlersRegistered = !0, t.types.split(",").forEach(function (n) {
        return t.listenOn.addEventListener(n.toLowerCase(), e["_handle" + c(n)] || t["on" + c(n)], t.useCapture);
      });
    }), f(u(e), "_unregisterListeners", function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e.props;
      e.handlersRegistered = !1, t.types.split(",").forEach(function (n) {
        return t.listenOn.removeEventListener(n.toLowerCase(), e["_handle" + c(n)] || t["on" + c(n)], t.useCapture);
      });
    }), f(u(e), "_handleClick", function (t) {
      var n, r;
      null === (n = (r = e.props).onClick) || void 0 === n || n.call(r, t), e.props.onClickOutside && !e.container.contains(t.target) && e.props.onClickOutside(t);
    }), f(u(e), "_handleKeydown", function (t) {
      var n, c, u, p, f, d, h, v, b, y, m, g, _, O;
      switch (t.keyCode) {
        case a:
          null === (u = (p = e.props).onEsc) || void 0 === u || u.call(p, t);
          break;
        case l:
          null === (f = (d = e.props).onArrowUp) || void 0 === f || f.call(d, t);
          break;
        case s:
          null === (h = (v = e.props).onArrowDown) || void 0 === h || h.call(v, t);
          break;
        case i:
          null === (b = (y = e.props).onArrowLeft) || void 0 === b || b.call(y, t);
          break;
        case o:
          null === (m = (g = e.props).onArrowRight) || void 0 === m || m.call(g, t);
          break;
        case r:
          null === (_ = (O = e.props).onEnter) || void 0 === _ || _.call(O, t);
      }
      (null === (n = (c = e.props).shouldPreventDefault) || void 0 === n ? void 0 : n.call(c, t)) && t.preventDefault();
    }), f(u(e), "_receiveContainer", function (t) {
      return e.container = t;
    }), e;
  }
  return b = [{
    key: "componentDidMount",
    value: function value() {
      this.props.disabled || this._registerListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.handlersRegistered && this._unregisterListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.listenOn !== this.props.listenOn ? (this._unregisterListeners(e), this.props.disabled || this._registerListeners(this.props)) : (!e.disabled && this.props.disabled && this._unregisterListeners(), e.disabled && !this.props.disabled && this._registerListeners());
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children ? e.createElement(this.props.tag, {
        ref: this._receiveContainer,
        className: n("global-event-listener", this.props.className)
      }, this.props.children) : null;
    }
  }], p(g.prototype, b), y && p(g, y), g;
}(t);
f(v, "defaultProps", {
  types: "keydown,click",
  tag: "div",
  useCapture: !1,
  disabled: !1,
  listenOn: document
});
export { v as GlobalListener };